
import state from './state'
import actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/features/admin/servicos/store/index.js